<div class="container">
  <div class="border-blue row">
    <div class="card full-width-card">
      <div class="card-body">
        <section>
          <h1 class="section-header">
            {{ "MANAGE_ACCOUNT" | globalTranslate }}
          </h1>
          <hr />
          <p class="pt-1">
            <strong>{{ "PERSON_LOGGED" | globalTranslate }}:</strong>
            {{ userDetails?.firstName }}
            {{ userDetails?.lastName }}
          </p>
          <p>
            <strong>{{ "USERNAME" | globalTranslate }}:</strong> {{ userName }}
          </p>
          <p>
            <strong>{{ "EMAIL_ADDRESS" | globalTranslate }}:</strong>
            {{ userDetails?.email }}
          </p>
          <h2 class="section-header">
            {{ "ACCOUNT_SETTING" | globalTranslate }}
          </h2>
          <hr />
          <p>{{ "ACCOUNT_SETTINGS_TEXT" | globalTranslate }}</p>

          <!-- Live region to announce selections and next steps -->
          <!-- globalTranslate -->
          <div
            class="visually-hidden"
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            @if (appType === 'updatePassword') {
            <span
              >{{ "UPDATE_PASSWORD" | globalTranslate
              }}{{ "MANAGE_ACCOUNT_SELECTED" | globalTranslate }}.
              {{ "MANAGE_ACCOUNT_NEXT_STEP" | globalTranslate }}</span
            >
            } @if (appType === 'updateEmail') {
            <span
              >{{ "UPDATE_COMMUNICATION" | globalTranslate
              }}{{ "MANAGE_ACCOUNT_SELECTED" | globalTranslate }}.
              {{ "MANAGE_ACCOUNT_NEXT_STEP" | globalTranslate }}</span
            >
            } @if (appType === 'updateSecurityQuestion') {
            <span
              >{{ "UPDATE_SECURITY_QUES" | globalTranslate
              }}{{ "MANAGE_ACCOUNT_SELECTED" | globalTranslate }}.
              {{ "MANAGE_ACCOUNT_NEXT_STEP" | globalTranslate }}</span
            >
            }
          </div>

          <div class="row">
            <div
              tabindex="0"
              class="card card-body shadow m-3"
              [ngClass]="{ applyColor: appType === 'updatePassword' }"
              [attr.aria-current]="appType === 'updatePassword'"
              [attr.aria-label]="'UPDATE_PASSWORD' | globalTranslate"
              (click)="selectedAction('updatePassword')"
              (keydown.enter)="selectedAction('updatePassword')"
              (keydown.space)="
                selectedAction('updatePassword'); $event.preventDefault()
              "
            >
              <div
                class="d-flex flex-column flex-sm-row align-items-center ps-2"
              >
                <div class="d-flex align-items-center me-sm-3 mb-2 mb-sm-0">
                  <div class="dot-password">
                    <img
                      src="../../../../assets/rt.svg"
                      alt=""
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="fw-bold text-center text-sm-start ms-3">
                  <strong>{{ "UPDATE_PASSWORD" | globalTranslate }}</strong>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              tabindex="0"
              class="card card-body shadow m-3"
              [ngClass]="{ applyColor: appType === 'updateEmail' }"
              [attr.aria-current]="appType === 'updateEmail'"
              [attr.aria-label]="
                ('UPDATE_COMMUNICATION' | globalTranslate) +
                '. ' +
                ('UPDATE_COMMUNICATION_DESC' | globalTranslate)
              "
              (click)="selectedAction('updateEmail')"
              (keydown.enter)="selectedAction('updateEmail')"
              (keydown.space)="
                selectedAction('updateEmail'); $event.preventDefault()
              "
            >
              <div
                class="d-flex flex-column flex-sm-row align-items-center ps-2"
              >
                <div class="d-flex align-items-center me-sm-3 mb-2 mb-sm-0">
                  <div class="dot-email">
                    <img
                      src="../../../../assets/cem.svg"
                      alt=""
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="fw-bold text-center text-sm-start ms-3">
                  <strong>{{
                    "UPDATE_COMMUNICATION" | globalTranslate
                  }}</strong>
                  <p>{{ "UPDATE_COMMUNICATION_DESC" | globalTranslate }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              tabindex="0"
              class="card card-body shadow m-3"
              [ngClass]="{ applyColor: appType === 'updateSecurityQuestion' }"
              [attr.aria-current]="appType === 'updateSecurityQuestion'"
              [attr.aria-label]="'UPDATE_SECURITY_QUES' | globalTranslate"
              (click)="selectedAction('updateSecurityQuestion')"
              (keydown.enter)="selectedAction('updateSecurityQuestion')"
              (keydown.space)="
                selectedAction('updateSecurityQuestion');
                $event.preventDefault()
              "
            >
              <div
                class="d-flex flex-column flex-sm-row align-items-center ps-2"
              >
                <div class="d-flex align-items-center me-sm-3 mb-2 mb-sm-0">
                  <div class="dot-questions">
                    <img
                      src="../../../../assets/security-Q.svg"
                      alt=""
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="fw-bold text-center text-sm-start ms-3">
                  <strong>{{
                    "UPDATE_SECURITY_QUES" | globalTranslate
                  }}</strong>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
